// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "patientDashboard." + ({"138":"profile","147":"app-routes","251":"checkout","352":"onboarding"}[chunkId] || chunkId) + "." + {"138":"2b2fd5d6a7dba98eb23f","147":"2db5e1483c422b0fff96","251":"8d6ead5719ff9c7e8a1d","352":"3c1e9d993968b960ebee","631":"7f6481807ea5020ff807"}[chunkId] + ".js";
};